import {IMessagesState, initialMessagesState} from '@app/core/store/state/messages.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EMessagesActions, MessagesActions} from '@app/core/store/actions/messages.actions';
import {SessionActions} from '@app/core/store/actions/session.actions';
import {EScheduleActions, ScheduleActions} from '@app/core/store/actions/schedule.actions';

export const messagesReducers = (
	state = initialMessagesState,
	action: MessagesActions | ErrorActions | SessionActions | ScheduleActions,
): IMessagesState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isConversationsLoading: false,
				isMessagesLoading: false,
				isLoadingSendingMessage: false,
			};
		}
		case EMessagesActions.GetConversations: {
			return {
				...state,
				isConversationsLoading: true,
			};
		}
		case EMessagesActions.GetConversationsSuccess: {
			return {
				...state,
				isConversationsLoading: false,
				conversations: action.conversations,
			};
		}
		case EMessagesActions.CreateConversation: {
			return {
				...state,
			};
		}
		case EMessagesActions.CreateConversationSuccess: {
			const conversations = state.conversations;
			if (!conversations.find(c => c.id === action.conversation.id)) {
				conversations.unshift(action.conversation);
			}
			return {
				...state,
				isConversationsLoading: false,
				conversations,
				selectedConversation: action.conversation,
				showOnlyMessages: true,
				createNewConversation: false,
			};
		}
		case EMessagesActions.GetMessages: {
			return {
				...state,
				isMessagesLoading: true,
			};
		}
		case EMessagesActions.GetMessagesSuccess: {
			return {
				...state,
				isMessagesLoading: false,
				messages: [...state.messages, ...action.messages],
				pagination: action.pagination,
			};
		}
		case EMessagesActions.CreateMessage: {
			return {
				...state,
				isLoadingSendingMessage: true,
			};
		}
		case EMessagesActions.CreateMessageSuccess: {
			let conversations = state.conversations.map(c => {
				if (state.selectedConversation && c.id === state.selectedConversation.id) {
					c.latest_message = action.message;
					c.updated_at = action.message.created_at;
					state.selectedConversation = c;
				}
				return c;
			});
			conversations = [state.selectedConversation, ...state.conversations.filter(c => state.selectedConversation && c.id !== state.selectedConversation.id)];

			return {
				...state,
				isLoadingSendingMessage: false,
				messages: [action.message, ...state.messages.filter(m => m.id !== action.message.id)],
				conversations,
			};
		}
		case EMessagesActions.FilterConversations: {
			const filtered = action.searchString === '' ?
				state.conversations
				: state.conversations.filter(c => c.conversation_name.toLowerCase().includes(action.searchString.toLowerCase()));
			return {
				...state,
				filteredConversations: filtered,
			};
		}
		case EMessagesActions.ClearFilteredConversations: {
			return {
				...state,
				filteredConversations: [],
			};
		}
		case EMessagesActions.ClearMessagesOnConversation: {
			return {
				...state,
				messages: [],
			};
		}
		case EMessagesActions.PostMessageFiles: {
			return {
				...state,
			};
		}
		case EMessagesActions.PostMessageFilesSuccess: {
			return {
				...state,
				messageFileEntries: action.filesEntries,
			};
		}
		case EMessagesActions.ClearMessageFiles: {
			return {
				...state,
				messageFileEntries: [],
			};
		}
		case EMessagesActions.CreateNewConversation: {
			return {
				...state,
				createNewConversation: action.newConversation,
				messages: [],
				showOnlyMessages: true,
				selectedConversation: undefined,
			};
		}
		case EMessagesActions.SetSelectedConversation: {
			const selectedConversation = action.conversation;
			selectedConversation.unread_notifications_count = 0;
			return {
				...state,
				selectedConversation,
				conversations: [...state.conversations.map(c => {
					if (c.id === action.conversation.id) {
						c.unread_notifications_count = 0;
					}
					return c;
				})],
				createNewConversation: false,
				showOnlyMessages: true,
			};
		}
		case EMessagesActions.SetShowOnlyMessages: {
			return {
				...state,
				showOnlyMessages: action.show,
			};
		}
		case EMessagesActions.LeaveConversationSuccess: {
			const conversations = [...state.conversations.filter(c => c.id !== action.id)];
			return {
				...state,
				conversations,
				selectedConversation: conversations[0],
			};
		}
		case EMessagesActions.RenameConversationSuccess: {
			const conversations = state.conversations.map(c => {
				if (c.id === action.conversation.id) {
					c = action.conversation;
				}

				return c;
			});

			return {
				...state,
				conversations,
				selectedConversation: action.conversation,
			};
		}
		case EMessagesActions.PushMessageToConversation: {
			let conversations = state.conversations;

			const conversationIndex = conversations.findIndex(c => c.id === action.conversation.id);

			// Do not push websocket conversation in array. It's does not have group/group.department/users.
			// If its not in the conversations, then the conversation will be refetched in the effect.
			if (conversationIndex !== -1) {
				const conversation = conversations[conversationIndex];
				conversation.unread_notifications_count++;
				conversation.latest_message = action.message;
				conversation.updated_at = action.message.created_at;

				conversations.splice(conversationIndex, 1);
				conversations = [conversation, ...conversations];
			}

			const messages = [...state.messages];
			if (state.selectedConversation && state.selectedConversation.id === action.conversation.id) {
				messages.unshift(action.message);
			}

			return {
				...state,
				messages,
				conversations,
			};
		}

		case EScheduleActions.AddShiftStockBid: {
			return {
				...state,
				isMessagesLoading: true,
			};
		}

		case EScheduleActions.AddShiftStockBidSuccess: {
			return {
				...state,
				isMessagesLoading: false,
				messages: state.messages.map(m => {
					if (m.shift?.id === action.shiftId) {
						m.shift.bid_on_shift = true;
					}

					return m;
				}),
			};
		}
		default:
			return state;
	}
};
